import attachment from './attachment.json';
import audio from './audio.json';
import auth from './auth.json';
import charts from './charts.json';
import global from './global.json';
import settings from './settings';
import validations from './validations.json';
import voip from './voip.json';
import whatsapp_template from './whatsapp_template.json';

export default {
  global,
  charts,
  voip,
  audio,
  attachment,
  validations,
  auth,
  whatsapp_template,
  settings,
};
